import axios from "axios";
const PROXY = process.env.REACT_APP_API_URL + 'api/olaleads/';

export const verifyLeadStatus = (formData) => async (dispatch) => {
    const res = await axios.post(PROXY + 'verify/leadStatus', formData);
    return res;
};

export const getFilterDropdownOptions = () => async (dispatch) => {
    const res = await axios.get(process.env.REACT_APP_API_URL + 'api/leads/filter-options');
    return res;
};